import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Mail: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--mail')}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      id="Mail-Icon-32x32"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fill="#000000" fillRule="nonzero">
        <g id="Email">
          <path d="M27.9543478,7.5 L27.9543478,24.5 L3.95434783,24.5 L3.95434783,7.5 L27.9543478,7.5 Z M5.45434783,9.799 L5.45434783,23 L26.4543478,23 L26.4543478,9.869 L16,17.9478254 L5.45434783,9.799 Z M25.1253478,9 L6.87434783,9 L16,16.0521746 L25.1253478,9 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Mail;
